// Body of the Oscar order-pending ("order error") view: the static order-error
// copy block. The copy arrives pre-localized as string props (server-side
// gettext) so any non-English locale is preserved -- React `t` would always
// emit English. The one exception is the "Shop Now" button label: it was a
// hardcoded literal in the original order_pending.html (not {% trans %}-wrapped,
// en-us only), so it is reproduced as a literal here.
import { Immutable } from "immer";
import React from "react";
import { FORM_FIELD_SUBMIT_CLASS_NAME } from "tsi-common-react/src/forms/classNames";

import { templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

type IProps = Immutable<templates.OrderPendingDocumentTemplate>;

export const OrderPendingBody = (props: IProps): React.JSX.Element => {
    return (
        <div className="thank-you-container l-capped-width u-margin-bottom--xl u-full-width-title">
            <div className="order-error">
                <div className="intro">
                    <h1 className="order-error__intro-title">
                        {props.intro_title}
                    </h1>
                    <div className="order-error__intro-copy">
                        <p>
                            {props.intro_line_1}
                            <br />
                            {props.intro_line_2}
                            <br />
                            {props.intro_line_3}
                        </p>
                        <ol>
                            {props.steps.map((step, i) => (
                                <li key={i}>{step}</li>
                            ))}
                        </ol>
                        <p>{props.reassurance}</p>
                    </div>
                    <div>
                        <p className="order-error__intro-copy--bold">
                            {props.contact_line}
                            <br />
                            {props.hours_line}
                        </p>
                    </div>
                    <div className="order-error__continue">
                        <a href="/">
                            <div
                                className={concatClassNames([
                                    "button",
                                    FORM_FIELD_SUBMIT_CLASS_NAME,
                                ])}
                            >
                                Shop Now
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
